import { useFormikContext } from 'formik';
import { CartFormikValues } from 'types/cart';

export const useCartFormikContext = () => useFormikContext<CartFormikValues>();
